import { DonationType } from '@nkr/enums/index';
import { Label } from 'react-bootstrap';

interface IProps {
    donationType: number, donationTypeAbbr: string
}

const DonationTypeRenderer = (props:IProps) => {
    if (props.donationType == DonationType.DirectedDonor || props.donationType == DonationType.Bridge) {
        return <Label>{props.donationTypeAbbr}</Label>;
    }

    if (props.donationType == DonationType.NonDirectedDonor) {
        return <Label bsStyle='warning'>{props.donationTypeAbbr}</Label>;
    }

    if ([DonationType.StandardVoucher, DonationType.FamilyVoucher, DonationType.SwapSaver, DonationType.RealTimeSwapFailure].indexOf(props.donationType) >= 0) {
        return <Label bsStyle='success'>{props.donationTypeAbbr}</Label>;
    }

    return <Label bsStyle='info'>{props.donationTypeAbbr}</Label>;
};

export default DonationTypeRenderer;